<template>
    <div class="E3Visa-main" style="padding:10px">
        <ob-spinner v-if="isLoading" loading-text="Loading..."></ob-spinner>
        <div v-else>
            <div v-if="E3VisaDocument.length != 0" class="E3Visa-header">
                <h4>E-3 Visa</h4>
            </div>
        <template>
           <div v-if="!isLoading && E3VisaDocument.length == 0" style="height: 400px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                    <h5 class="pfa-info_msg">
                        Attention! The E-3 Visa folder does not contain any documents at the moment. Please contact your employer for clarification!
                    </h5>
                </div>
            </div>
            <div v-else>
                <div v-for="(e3DocObj, index) in E3VisaDocument" :key="index">
                    <ob-l1visa-document :documentObj="e3DocObj" :index="index" @removeDocument="getDocsList"> </ob-l1visa-document>
                </div> 
                <div v-for="(otherDocObj, index) in otherDocumentList" :key="`section-${index}`">
                    <ob-l1visa-document :documentObj="otherDocObj" @removeOtherDocument="getDocsList"> </ob-l1visa-document>
                </div> 
             
            </div> 
        </template>
        </div>
       
    </div>
</template>

<script>
    export default {
        data() {
            return { 
                isLoading:false,
                doValidation: false,
                isFormValid: false,
                E3VisaDocument: [],
                I94VisaDocument: [],
                E3VisaDocument:[],
                otherDocumentList: [],
                EmployeeId:'',
                openUploadL1E3TN:false,
                documentsData:{},
                E3MetadataFields:{
                      DocumentData:[],
                      DocumentId:""
                },
                I94MetadataFields:{
                      DocumentData:[],
                      DocumentId:""
                },
                openOtherDocUpload:false,
                documentId:"",
                isUpdate:false,
                isUpdateOtherDoc:false,
                indexValue:0,
                uploadE3PoupFromBanner:'',
                emptySection: false

            }
        },
         methods: {
            getDocsList(){
                this.isLoading = true
                ajax.get(`Employee/${loggedInUserObj.empId}/GetL1E3TNDocuments?docGroup=E3`,{},(res) => {
                    if (res.data.State) {
                        this.isLoading = false
                        this.E3VisaDocument = []
                        this.otherDocumentList = []
                        this.E3MetadataFields={
                            DocumentData:[],
                            DocumentId:""
                        },
                        this.I94MetadataFields={
                            DocumentData:[],
                            DocumentId:""
                        },
                        this.documentsData = res.data.Documents
                        this.E3Metadata = this.documentsData.Metadata.E3Metadata.Metadata
                        this.I94Metadata = this.documentsData.Metadata.I94Metadata.Metadata
                        if(this.E3Metadata != null && this.E3Metadata.length > 0){
                            this.E3Metadata.forEach((v) => {
                                var obj={
                                    Key : v.Key,
                                    Value : ""
                                }
                                this.E3MetadataFields.DocumentData.push(obj)                                
                            })
                        }
                        if(this.I94Metadata != null && this.I94Metadata.length > 0){
                            this.I94Metadata.forEach((v) => {
                                var obj={
                                    Key : v.Key,
                                    Value : ""
                                }
                                this.I94MetadataFields.DocumentData.push(obj)                                
                            })
                        }
                         if(res.data.Documents.DocList != null && res.data.Documents.DocList != '' && res.data.Documents.DocList.length > 0){
                            this.E3VisaDocument = res.data.Documents.DocList                            
                        }
                        if(res.data.Documents.OtherDocList != null && res.data.Documents.OtherDocList != '' && res.data.Documents.OtherDocList.length > 0){
                            this.otherDocumentList = res.data.Documents.OtherDocList
                        }
                       
                    }
                    else{
                        this.isLoading = false
                        this.$message({
                            type: "error",
                            message: res.data.Message
                        });
                    }
                })
            },
          
        },        
        components:{
        },
        computed: {            
           status() {
                return this.E3VisaDocument.length > 0 ? 'success' : 'default'
            },  
            statusClass() {
                if (this.status === 'default') {
                    return 'document-list--default'
                } else if (this.status === 'success') {
                    return 'document-list--success'
                } else if (this.status === 'failure') {
                    return 'document-list--failure'
                } else if (this.status === 'warning') {
                    return 'document-list--warning'
                } 
            },
        },
        created() {
            this.getDocsList()
        },
        watch: {
           emptySection(){
           } 
        },
    }
</script>

<style lang="scss" scoped>
@import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/progress-bars";

    $default-border-color : #c2c2c2; $default-background-color: #fdfdfd; $success-border-color : #a4f3b5; $success-background-color: #f4fef7; .document-list {
        /*border-bottom: 1px dashed #ccc;*/
        padding: 15px 10px 15px 0px;
    }
.E3Visa-main {
    .E3Visa-header
    {
        display: inline-block;
        width: calc(100% - 30px);
        padding: 15px 0;
        border-bottom: dashed 1.4px #b5b5b5;
        margin: 0 15px;
        h4
        {
            display: inline-block;
            color: #143361;
            font-weight: bold;
        }
        .init-button {
            display: inline-block;
            float: right;
        }
    }
    .E3Visa-body {
        padding: 15px;
        display: inline-block;
        .E3Visa-info_msg
        {
            margin: 0;
            color: #a29f9f;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
        }

    }
}  
.document-list__heading {
        padding: 5px 10px;
        border: 1px solid $default-border-color;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: $default-background-color;
        float: left;
    }

    .document-list__status {
        background: $default-border-color;
        color: $default-background-color;
        padding: 0px 5px;
        border-radius: 100%;
    }
    // .section{
    //     padding: 0px;
    //     border-bottom: 1px dashed #b5b5b5;
    // }
    .document-list__controls {
        float: right;
        top: 15px;
        position: absolute;
        right: 15px;
    }
    .upload-list__controls {
        float: right;
        top: 15px;
        right: 15px;
    }

    .document-list.document-list--success {
        .document-list__heading
        {
            border: 1px solid #1DC942;
            background: $success-background-color;
            margin-left: 1%;
        }
        .document-list__status {
            background: $success-border-color;
            color: #1DC942;
        }

    } 
    .file_name_span {
        //overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        //max-width: 600px;
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpE3Visa.vue